<script setup>
import { defineProps, defineEmits } from "vue";

defineEmits(["update:modelValue"]);

const props = defineProps({
  vuelidateField: {
    type: Object,
    default: () => {},
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: "",
  },
  id: {
    type: String,
    default: "",
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div>
    <label :for="props.id" class="inline-flex text-sm font-medium">
      <input
        :id="props.id"
        type="checkbox"
        :checked="props.modelValue"
        :data-cy="props.id + 'Checkbox'"
        class="custom-checkbox h-5 w-5 border-gray-300 text-indigo-base focus:ring-indigo-base"
        :disabled="props.isDisabled"
        @change="$emit('update:modelValue', $event.target.checked)"
      />
      <span class="ml-4">
        {{ props.label }}
        <slot name="label"></slot>
      </span>
    </label>
    <p
      v-for="error of props.vuelidateField?.$errors"
      :key="error.$uid"
      class="error text-error-900 text-sm"
    >
      {{ error.$message }}
    </p>
  </div>
</template>

<style scoped>
.custom-checkbox:checked {
  accent-color: #1e264c;
}
</style>
